import type { ComponentType, SVGProps } from "react";

import { cn } from "@/utils/shadcn-ui";

import { FlagDe } from "./flag-de";
import { FlagGb } from "./flag-gb";
import { FlagIt } from "./flag-it";
import { FlagPl } from "./flag-pl";
import { FlagSk } from "./flag-sk";

/** Decorative flag for one of the app's switchable locales — renders nothing for
 * a locale we have no flag for, so callers can pass `i18n.locale` directly. */
export function LocaleFlag({
  locale,
  className,
}: {
  locale: string;
  className?: string;
}) {
  const Flag = flagsByLocale[locale];
  if (!Flag) return null;

  return (
    <Flag
      aria-hidden
      // The `!` keeps the 4:3 box when rendered inside a button, which forces
      // `size-4` onto any svg without a `size-*` class of its own.
      className={cn("h-3! w-4! shrink-0 rounded-[2px]", className)}
    />
  );
}

/** Keep in sync with `switchableLocales` in `src/i18n.react.ts`. */
const flagsByLocale: Record<string, ComponentType<SVGProps<SVGSVGElement>>> = {
  en: FlagGb,
  de: FlagDe,
  it: FlagIt,
  pl: FlagPl,
  sk: FlagSk,
};
